export const defaultSortFields = {
  name: null,
  sequence: 1,
  order: 'ASC',
};
